import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SimulationSession } from '../models/simulation.model';
import { VehicleColor, VehicleModel } from '../models/vehicles.model';
import { LocalStorageService } from './local-storage.service';

@Injectable({
	providedIn: 'root',
})
export class SimulationService {
	constructor(
		private localStorage: LocalStorageService,
		private readonly http: HttpClient
	) {}

	private _sessionSubject = new BehaviorSubject<SimulationSession[]>([]);
	session$ = this._sessionSubject.asObservable();

	get vehicleModelList(): VehicleModel[] {
		return (JSON.parse(this.localStorage.getItem('ROD-simulation.vehicleClass')!) || []) as VehicleModel[];
	}

	get colorsList(): VehicleColor[] {
		return (JSON.parse(this.localStorage.getItem('ROD-simulation.selectedColor')!) || []) as VehicleColor[];
	}

	get simulationSession(): SimulationSession[] {
		return this.localStorage.getItem('ROD-simulation') ? ((JSON.parse(this.localStorage.getItem('ROD-simulation')!) || []) as SimulationSession[]) : [];
	}

	getSimulationSession(): SimulationSession[] {
		return this.localStorage.getItem('ROD-simulation') ? ((JSON.parse(this.localStorage.getItem('ROD-simulation')!) || []) as SimulationSession[]) : [];
	}

	retrieveSessionFromStorage() {
		const sessionData = this.localStorage.getItem('ROD-simulation') ? JSON.parse(this.localStorage.getItem('ROD-simulation')!) : [];
		this._sessionSubject.next(sessionData as SimulationSession[]);
	}

	get temporaryCart(): SimulationSession[] {
		return this.localStorage.getItem('ROD-temporaryCart') ? ((JSON.parse(this.localStorage.getItem('ROD-temporaryCart')!) || []) as SimulationSession[]) : [];
	}

	getTemporaryCart(): SimulationSession[] {
		return this.localStorage.getItem('ROD-temporaryCart') ? ((JSON.parse(this.localStorage.getItem('ROD-temporaryCart')!) || []) as SimulationSession[]) : [];
	}

	sendToMail(simulationId: string, basketId: string, payload: any) {
		return this.http.post<any>(`${environment.apiUrl}simulations/${simulationId}/baskets/${basketId}/emails`, payload);
	}

	cleanSimulation() {
		this.localStorage.removeItem('ROD-basketId');
		this.localStorage.removeItem('ROD-simulation');
		this.localStorage.removeItem('hasSimulations');
	}
}
